// Admin routes for P7-B (NOTIFY-01/02/04/05, MAIL-01). Owned by that worker; the router mounts
// whatever this returns under the app shell (before the store-area placeholder), so modules never
// edit router.tsx. Paths follow IA §2.1:
//   …/notifications            the notification centre (every member, own rows)
//   …/settings/notifications   own prefs + push on this device; templates, senders, forwarding
//                              (settings.notifications; Owner for senders and forwarding)
import {
  createRoute,
  type AnyRoute,
  type RouteComponent,
  lazyRouteComponent,
} from "@tanstack/react-router";

// Pages are code-split: each loads when its route opens, not with the shell.
const load1 = () => import("../notifications/NotificationCentre");
const NotificationCentrePage = lazyRouteComponent(load1, "NotificationCentrePage");
const load2 = () => import("../notifications/NotificationSettings");
const NotificationSettingsPage = lazyRouteComponent(load2, "NotificationSettingsPage");

export function notificationsRoutes(appRoute: AnyRoute): AnyRoute[] {
  const at = (path: string, component: RouteComponent) =>
    createRoute({ getParentRoute: () => appRoute, path, component });
  return [
    at("/$org/$store/notifications", NotificationCentrePage),
    at("/$org/$store/settings/notifications", NotificationSettingsPage),
  ];
}
